import React from 'react';
import PropTypes from 'prop-types';
import { LinearProgress, withStyles } from '@material-ui/core';

const BorderLinearProgress = withStyles((theme) => ({
    bar: {
      borderRadius: 5,
      backgroundColor: props => props.progresscolor,
    },
}))(LinearProgress);

  
const PasswordBarLineIndicator = props => {
    const { progress, progresscolor } = props
    return (
        <BorderLinearProgress variant="determinate" value={progress}  progresscolor ={progresscolor}/>
    );
};

PasswordBarLineIndicator.propTypes = {
    progress: PropTypes.number.isRequired,
};

export default PasswordBarLineIndicator